var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"mask-closable":true,"title":_vm.title,"footer-hide":true,"scrollable":false,"class-name":"QHImgopen","width":_vm.openWidth(_vm.width)},on:{"on-cancel":function($event){return _vm.close()}},model:{value:(_vm.ModalShow),callback:function ($$v) {_vm.ModalShow=$$v},expression:"ModalShow"}},[_c('img',{attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }